<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    @ok="videoSure"
    @cancel="close"
    cancelText="关闭">
    <a-row class="form-row">
      <a-col :span="7">
        <a-form-item label="视频上传" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-upload
            listType="text"
            class="avatar-uploader"
            :showUploadList="true"
            :action="uploadAction"
            :data="{'isup':1}"
            :headers="headers"
            :multiple="true"
            :beforeUpload="beforeUpload"
            @change="handleChange"
          >
            <a-button>
              <a-icon :type="uploadLoading ? 'loading' : 'upload'"/>
              点我
            </a-button>
          </a-upload>
        </a-form-item>
      </a-col>
      <a-col :span="7">
        <a-form-item label="循环播放" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select placeholder="请选择" style="width: 100px" v-model="form.repeatFlag">
            <a-select-option value="1">是</a-select-option>
            <a-select-option value="0">否</a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="7">
        <a-form-item label="默认播放" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number :min="1" v-model="form.defaultFlag"></a-input-number>
        </a-form-item>
      </a-col>
    </a-row>


    <a-row class="form-row" :gutter="24" v-for="(fData,index) in fileDatas" :key="index">
      <a-col :md="8" :sm="8">
        <a-form-item label="文件名" :labelCol="{span: 10}" :wrapperCol="{span: 10}">
          <a-input v-model="fData.fileName"/>
        </a-form-item>
      </a-col>

      <a-col :md="10" :sm="8">
        <a-form-item label="播放标识" :labelCol="{span: 5}" :wrapperCol="{span: 10}">
          <a-input v-model="fData.flag"/>
        </a-form-item>
      </a-col>

      <a-col :md="6" :sm="8">
        <a-button type="danger" icon="delete" @click="handleDelete(index)">
          删除
        </a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
  export default {
    name: "eleVideosSimple",
    components: {},
    props: {
      uploadParam: {
        type: Object,
      },
    },
    data() {
      return {
        fileDatas: [],
        form: {},
        title: '视频组件编辑',
        uploadLoading: false,
        headers: {},
        formLabelWidth: '120px',
        visible: false,
        colKey: '',
        componentFlag: '',
        labelCol: {
          xs: {span: 10},
          sm: {span: 8},
        },
        wrapperCol: {
          xs: {span: 10},
          sm: {span: 12},
        },
      }
    },
    computed: {
      uploadAction: function () {
        return this.uploadParam.fileUpload;
      }
    },
    created() {
      this.headers = {"X-Access-Token": this.uploadParam.accessToken}
    },
    methods: {
      beforeUpload: function (file) {
        let fileSize = file.size / 1024 / 1024 < 50;
        if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb',
          'video/mov'].indexOf(file.type) == -1) {
          this.$message.warning("请上传正确的视频格式");
          return false;
        }
        if (!fileSize) {
          this.$message.warning("视频大小不能超过50MB");
          return false;
        }
      },
      handleChange(info) {
        if (info.file.status === 'uploading') {
          this.uploadLoading = true;
          return
        }
        if (info.file.status === 'done') {
          let response = info.file.response;
          this.uploadLoading = false;
          if (response.success) {
            let filePath = this.uploadParam.imgerver + "/" + response.message;
            this.fileDatas.push({fileName: info.file.name, filePath: filePath, flag: ""});
          } else {
            this.$message.warning(response.message);
          }
        }
      },
      videoSure() {
        this.visible = false;
        this.$emit('setComponentData',
          JSON.stringify(Object.assign(this.form, {param: JSON.stringify(this.fileDatas)})),
          this.colKey, this.componentFlag);
      },
      edit(colKey, componentFlag, componentDataStr) {
        this.visible = true;
        this.colKey = colKey;
        this.componentFlag = componentFlag;
        //非新增
        if (undefined != componentDataStr) {
          const componentData = JSON.parse(componentDataStr);
          this.form = {
            repeatFlag: componentData.repeatFlag,
            defaultFlag: componentData.defaultFlag
          }
          this.fileDatas = JSON.parse(componentData.param);
        }
      },
      close() {
        this.visible = false;
      },
      handleDelete(index) {
        this.fileDatas.splice(index, 1);
      }
    }
  }
</script>

<style scoped>
  .avatar-uploader > .ant-upload {
    width: 104px;
    height: 104px;
  }
</style>



// WEBPACK FOOTER //
// src/lib/editMoudle/eleVideosSimple.vue